import React from 'react';
import ChecklistElement from './ChecklistElementModel';
import EditorType from '../../../Enums/EditorType';
import type { JSX } from 'react';
import { QuickTextInput } from 'shouldve-been-mui';

class LookupChecklistElement extends ChecklistElement {

    private _lookupType: string;
    private _dependentElementId: string;

    public constructor(elementId: string, name: string, itemNumber: string | null, sortNumber: number, lookupType: string, dependentElementId: string) {

        super(elementId, name, itemNumber, sortNumber, EditorType.LOOKUP);
        this._lookupType = lookupType;
        this._dependentElementId = dependentElementId;
    }

    public get lookupType(): string {
        return this._lookupType;
    }

    public set lookupType(value: string) {
        this._lookupType = value;
    }

    public get dependentElementId(): string {
        return this._dependentElementId;
    }

    public set dependentElementId(value: string) {
        this._dependentElementId = value;
    }

    public buildFormElement(value: string, onBlur: (value: string) => Promise<void>, screenWidth: number): JSX.Element {

        return (
            <React.Fragment key={this.elementId}>
                <QuickTextInput
                    value={value}
                    variant='outlined'
                    dense={true}
                    minWidth={Math.min(screenWidth * 0.8, 500)}
                    maxWidth={Math.min(screenWidth * 0.8, 500)}
                    labelText={this.name}
                    height='40px'
                    disabled={true}
                />
                <br />
                <br />
            </React.Fragment>
        );
    }
}

export default LookupChecklistElement;